import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Legacy redirect: /p/:slug -> /:slug (canonical public CMS URL).
 * We keep the route for back-compat (existing emails, bookmarks, sitemap, etc).
 */
export default function LegacyCmsRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (slug) navigate(`/${slug}`, { replace: true });
  }, [slug, navigate]);
  return null;
}
